import { render, staticRenderFns } from "./TopicScreen.vue?vue&type=template&id=609add9a&"
import script from "./TopicScreen.vue?vue&type=script&lang=js&"
export * from "./TopicScreen.vue?vue&type=script&lang=js&"
import style0 from "./TopicScreen.vue?vue&type=style&index=0&id=609add9a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609add9a')) {
      api.createRecord('609add9a', component.options)
    } else {
      api.reload('609add9a', component.options)
    }
    module.hot.accept("./TopicScreen.vue?vue&type=template&id=609add9a&", function () {
      api.rerender('609add9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/support/screens/TopicScreen.vue"
export default component.exports